module.exports = __webpack_public_path__ + "static/media/noises.3053806c.svg";